import "./Compliance2.module.css";
import Header from "@/reusable_sections/Header";
import Compliance from "./sections/Compliance";
import Compliancedocumentresources from "./sections/Compliancedocumentresources";
import Footer from "@/reusable_sections/Footer";
export default function Compliance2Page() {
  return <div>
      <Header />
      <Compliance />
      <Compliancedocumentresources />
      <Footer />
    </div>;
}